import React from 'react'
import Link from 'gatsby-link'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import withStyles from '@material-ui/core/styles/withStyles'

const styles = {
  header: {
    textAlign: 'center',
    padding: 10,
  },
}

const NotFoundPage = ({ classes }) => (
  <React.Fragment>
    <Typography
      classes={{ root: classes.header }}
      variant="title"
      align="center"
    >
      Page Not Found
    </Typography>
    <Typography variant="body1" align="center">
      That route does not exist. Please try elsewhere.
    </Typography>
    <div style={{ textAlign: 'center', padding: 10 }}>
      <Link to="/">Go to homepage</Link>
    </div>
  </React.Fragment>
)

NotFoundPage.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(NotFoundPage)



// WEBPACK FOOTER //
// ./src/pages/404.js